import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './file-loader.styl'
import { delayRender } from 'helpers/decorators'

const CardLoader = ({ secondary }) => (
  <div className={cx(styles.wrap, { [styles.secondary]: secondary })}>
    <div className="row">
      <div className="col-xs-12 col-sm-6">
        <div className={styles.loader}>
          <div className={styles.avatar} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
        <div className={styles.loader}>
          <div className={styles.avatar} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
      </div>
      <div className="col-xs-12 col-sm-6">
        <div className={styles.loader}>
          <div className={styles.avatar} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
        <div className={styles.loader}>
          <div className={styles.avatar} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
      </div>
    </div>
  </div>
)

CardLoader.propTypes = {
  secondary: PropTypes.bool
}

CardLoader.defaultProps = {}

export default delayRender()(CardLoader)
